import { DsButton } from '@frontends/ds';
import { type BaseSyntheticEvent, memo } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { OnboardingSchemaAddressInformationType } from '@/types/Onboarding.ts';
import FormTextField from '../../components/FormTextField.tsx';

export const OnboardingAddressInfoUpdate = memo(function OnboardingAddressInfoUpdate({
  onboardingAddressInfoForm,
  onboardingAddressInfoOnSubmit,
  isPending,
}: {
  onboardingAddressInfoForm: UseFormReturn<OnboardingSchemaAddressInformationType>;
  onboardingAddressInfoOnSubmit: (data: OnboardingSchemaAddressInformationType, e?: BaseSyntheticEvent) => void;
  isPending: boolean;
}) {
  const { t } = useTranslation();

  return (
    <form onSubmit={onboardingAddressInfoForm.handleSubmit(onboardingAddressInfoOnSubmit)}>
      <div className="grid gap-6">
        <div className="grid gap-2">
          <FormTextField
            control={onboardingAddressInfoForm.control}
            name="state"
            id="state"
            label={t('state')}
            placeholder="New York"
            isRequired
          />
        </div>
        <div className="grid gap-2">
          <FormTextField
            control={onboardingAddressInfoForm.control}
            name="postcode"
            id="postcode"
            label={t('postal_code')}
            placeholder="0200 - 9729"
            isRequired
          />
        </div>
        <div className="grid gap-2">
          <FormTextField
            control={onboardingAddressInfoForm.control}
            name="city"
            id="city"
            label={t('city')}
            placeholder="New York"
            isRequired
          />
        </div>
        <div className="grid gap-2">
          <FormTextField
            control={onboardingAddressInfoForm.control}
            name="address"
            id="address"
            label={t('address')}
            placeholder="47 West 13th Street"
            isRequired
          />
        </div>
        <DsButton type="submit" size="lg" className="w-full" isPending={isPending}>
          {t('update_address_info')}
        </DsButton>
      </div>
    </form>
  );
});
